/** @format */

enum TYPES {
	SET_ACTIVE_LOAN_SUMMARY = 'SET_ACTIVE_LOAN_SUMMARY',
	SET_ERROR_FOR_ACTIVE_LOAN_SUMMARY = 'SET_ERROR_FOR_ACTIVE_LOAN_SUMMARY',
	SET_LOANS = 'SET_LOANS',
	SET_ERROR_FOR_LOANS = 'SET_ERROR_FOR_LOANS',
}

export default TYPES;
